export const APPLY_SCAN_MODE = "APPLY_SCAN_MODE";